module.exports = __webpack_public_path__ + "static/media/CM3-Splash-Photo-Light.3918326e.jpg";